import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { FaUserFriends, FaCheckSquare, FaRegSquare, FaSave } from "react-icons/fa";
import Modal from "../Modal";

export default function ModalAsistenciaClub({ club, fecha, onClose, onSave }) {
  const { token } = useContext(AuthContext);
  const [miembros, setMiembros] = useState([]);
  const [asistencia, setAsistencia] = useState({});
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ mostrar: false, mensaje: "", tipo: "success" });

  const mostrarToast = (mensaje, tipo = "success") => {
    setToast({ mostrar: true, mensaje, tipo });
    setTimeout(() => setToast({ mostrar: false, mensaje: "", tipo: "success" }), 3000);
  };

  // 🔹 Cargar miembros del club y asistencia del día
  const cargarMiembros = async () => {
    try {
      const res = await fetch(
        `/api/miembros-club/${club.id_club}`,
        { credentials: "include", headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      setMiembros(data);

      // Inicializar asistencia
      const asistenciaInicial = {};
      data.forEach((m) => (asistenciaInicial[m.id_miembro] = false));

      // Obtener asistencia existente para la fecha
      const resAsis = await fetch(
        `/api/asistencia-club/${club.id_club}/${fecha}`,
        { credentials: "include", headers: { Authorization: `Bearer ${token}` } }
      );
      const dataAsis = await resAsis.json();
      dataAsis.forEach((a) => {
        asistenciaInicial[a.id_miembro] = a.presente;
      });

      setAsistencia(asistenciaInicial);
    } catch (error) {
      console.error("Error cargando miembros/asistencia:", error);
    }
  };

  useEffect(() => {
    cargarMiembros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [club, fecha]);

  // 🔹 Marcar/desmarcar asistencia
  const toggleAsistencia = (id) => {
    setAsistencia({ ...asistencia, [id]: !asistencia[id] });
  };

  // 🔹 Guardar asistencia
  const guardar = async () => {
    setLoading(true);
    try {
      const miembrosGuardar = miembros.map((m) => ({
        id_miembro: m.id_miembro,
        presente: asistencia[m.id_miembro],
        observaciones: "",
      }));

      const res = await fetch("/api/asistencia-club", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id_club: club.id_club, fecha, miembros: miembrosGuardar }),
      });

      if (!res.ok) throw new Error("No se pudo guardar la asistencia");

      onSave();
    } catch (error) {
      console.error(error);
      mostrarToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={true} onClose={onClose} title={`Asistencia - ${club.nombre_club} (${fecha})`} maxWidth="max-w-2xl">

      {toast.mostrar && (
        <div className={`fixed top-5 right-5 z-[70] px-4 py-3 rounded-lg shadow-lg text-sm text-white ${toast.tipo === "success" ? "bg-emerald-600" : "bg-rose-600"}`}>
          {toast.mensaje}
        </div>
      )}

      {/* Lista de miembros */}
      <div className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
        {miembros.length === 0 ? (
          <p className="text-sm text-slate-400 text-center py-8">Este club aún no tiene miembros registrados.</p>
        ) : (
          miembros.map((m) => {
            const presente = asistencia[m.id_miembro] || false;
            return (
              <label
                key={m.id_miembro}
                className={`flex items-center justify-between gap-3 p-3 rounded-lg border cursor-pointer transition ${
                  presente ? "bg-indigo-50 border-indigo-200" : "bg-white border-slate-200 hover:bg-slate-50"
                }`}
              >
                <span className="flex items-center gap-2 min-w-0">
                  <span className="w-7 h-7 rounded-md bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                    <FaUserFriends className="text-xs" />
                  </span>
                  <span className="truncate">
                    <span className="text-sm font-medium text-slate-800">
                      {m.nombre} {m.paterno} {m.materno}
                    </span>
                    <span className="ml-2 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-500">
                      {m.tipo === 1 ? "Responsable" : "Colaborador"}
                    </span>
                  </span>
                </span>

                {presente ? (
                  <FaCheckSquare className="text-indigo-600 shrink-0" />
                ) : (
                  <FaRegSquare className="text-slate-300 shrink-0" />
                )}

                <input
                  type="checkbox"
                  checked={presente}
                  onChange={() => toggleAsistencia(m.id_miembro)}
                  className="hidden"
                />
              </label>
            );
          })
        )}
      </div>

      {/* Botones */}
      <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-slate-100">
        <button
          onClick={onClose}
          className="px-3.5 py-1.5 text-sm rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
        >
          Cancelar
        </button>
        <button
          onClick={guardar}
          disabled={loading}
          className="flex items-center gap-1.5 px-3.5 py-1.5 text-sm rounded-lg bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white font-medium transition"
        >
          <FaSave className="text-xs" /> {loading ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </Modal>
  );
}
